module.exports = __webpack_public_path__ + "static/media/_order_complete.1d7acca4.png";